export default __webpack_public_path__ + "static/media/logo-branco.0c4b3183.png";